export default __webpack_public_path__ + "static/media/pandas.7ac31db2.png";